import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dispatch } from 'redux'
import { DataTypePregunta } from '../../../interfaces/utils'
import { AllCardsType } from '../../../data/all-cards'
import { Zodiaco, ZodiacoType } from '../../../data/zodiaco'
import {copyResponse,
    fotoCartas,
    getMazo,
    getMazoName,
    getTapiz,
    getZodiac,
    isEmpty,
    selectCards,
    setMezcla, formatSignAndAge} from '../../../utils/functions'
import { SaveAllCards, SetConsult } from '../../../store/actions'
import { ButtonNormal } from '../../../components/buttons/button-normal'
import { ButtonReinterpret } from '../../../components/buttons/button-reinterpret'
import { ShowCards } from './show-cards'
import PhotoCards from './photo-cards'
import { interpretPropia } from './functions'
import { useNavigate } from 'react-router-dom'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import ContentPasteIcon from '@mui/icons-material/ContentPaste'
import MarqueeText from '../../../components/MarqueeText'

const Sino = () => {
    const navigate = useNavigate()
    const dispatch: Dispatch<any> = useDispatch()
    const [data, setData] = useState<DataTypePregunta>({
        consultante: {
            name: '',
            date: '',
            zodiac: '',
            phone: '',
        },
        consulta: '',
    })
    const [copia, setCopia]: any = useState(false)
    const { allCards, user, consult } = useSelector((state: any) => state)
    const [response, setResponse] = useState('')
    const [selectedCards, setSelectedCards] = useState<AllCardsType[]>([])
    const [showResponse, setShowResponse] = useState<boolean>(false)
    const [status, setStatus] = useState({
        isDone: false,
        mezcladas: false,
        repartidas: false,
        isConsulting: false,
        isInterpret: false,
    })
    const zodiaco: ZodiacoType[] = Zodiaco

    // SETEA LOS ESTADOS PARA REALIZAR UNA NUEVA CONSULTA CON EL MISMO CLIENTE
    const nuevaPregunta = () => {
        setResponse('')
        setStatus({
            ...status,
            isDone: false,
            mezcladas: false,
            repartidas: false,
            isInterpret: false,
        })
        setData({
            ...data,
            consulta: '',
        })
        setShowResponse(false)
        setSelectedCards([])
    }

    // LIMPIA LOS ESTADOS PARA ATENDER UN NUEVO CLIENTE
    const nuevoCliente = () => {
        setResponse('')
        setStatus({
            ...status,
            isDone: false,
            mezcladas: false,
            repartidas: false,
            isInterpret: false,
        })
        setData({
            consultante: {
                name: '',
                date: '',
                zodiac: '',
            phone: '',
            },
            consulta: '',
        })
        setShowResponse(false)
        setSelectedCards([])
    }

    // MANEJA LOS ESTADOS
    const handleStatus = (name: string, value: boolean): void => {
        setStatus({
            ...status,
            [name]: value,
        })
    }

    // RECIBE UNA FECHA Y DEVUELVE EL SIGNO ZODIACAL
    const handleZodiacConsultant = (date: string): void => {
        let zodiac = getZodiac(date)
        setData({
            ...data,
            consultante: {
                ...data.consultante,
                zodiac,
                date,
            },
        })
    }

    // MANEJA LOS INPUTS DE LOS DATOS DEL CONSULTANTE
    const handleInputConsultant = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if (event.target.name === 'date' && parseInt(event.target.value.slice(0, 4)) > 1900) {
            handleZodiacConsultant(event.target.value)
        } else {
            setData({
                ...data,
                consultante: {
                    ...data.consultante,
                    [event.target.name]: event.target.value,
                },
            })
        }
    }

    // MANEJA EL TEXTAREA DE LA CONSULTA
    const handleConsult = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
        setData({
            ...data,
            consulta: event.target.value,
        })
    }

    // MEZCLA LAS CARTAS
    const mezcla = () => {
        const mezcladas = setMezcla(allCards)
        dispatch(SaveAllCards(mezcladas))
        handleStatus('mezcladas', true)
    }

    // PREPARA LA INFORMACION Y DISPARA LA CONSULTA A LA IA
    const interpretar = () => {
        handleStatus('isConsulting', true)
        const info = interpretPropia(selectedCards, data, user.username, 'sino')
        dispatch(SetConsult(info))
    }

    useEffect(() => {
        if (status.mezcladas && !status.repartidas) {
            setSelectedCards(selectCards(allCards, 5))
            setStatus((s) => ({ ...s, repartidas: true }))
        }
    }, [allCards, status.mezcladas, status.repartidas])

    useEffect(() => {
        if (!isEmpty(consult)) {
            setStatus((s) => ({
                ...s,
                isConsulting: false,
                isInterpret: true,
            }))
            setResponse(consult.response)
            setShowResponse(true)
        }
    }, [consult])

    useEffect(() => {
        if (Object.entries(user).length === 0) {
            navigate('/')
        }
    }, [user, navigate])

    useEffect(() => {
        if (Object.entries(user).length === 0) {
            navigate('/')
        }
        setStatus({
            isConsulting: false,
            isInterpret: false,
            isDone: false,
            repartidas: false,
            mezcladas: false,
        })
        setShowResponse(false)
        setResponse('')
        setSelectedCards([])
    // eslint-disable-next-line react-hooks/exhaustive-deps -- inicialización solo al montar
    }, [])

    // MUESTRA UNA DERSCRIPCION DEL SIGNO DEL ZODIACO DEL CONSULTANTE
    useEffect(() => {
        if (showResponse) {
            let signoConsultante = document.getElementById('consultante')
            if (signoConsultante && data.consultante.zodiac.length > 0) {
                let description = zodiaco.filter((signo) => signo.name === data.consultante.zodiac)
                signoConsultante.innerHTML = description[0].description
            }
        }
    }, [showResponse, data, zodiaco])

    // COPIA LA IMAGEN DE LAS CARTAS
    useEffect(() => {
        if (copia) {
            let element = document.getElementById('photo')
            if (element) {
                fotoCartas(element, data.consultante.name)
                setCopia(false)
            }
        }
    }, [copia, data.consultante.name])

    const copiar = () => {
        localStorage.setItem('client', JSON.stringify(data.consultante))
    }

    const pegar = () => {
        const cliente = localStorage.getItem('client')
        if (cliente) {
            const clienteObj = JSON.parse(cliente)
            console.log(clienteObj)
            setData({
                ...data,
                consultante: {
                    name: clienteObj.name,
                    date: clienteObj.date,
                    zodiac: clienteObj.zodiac,
                    phone: clienteObj.phone || '',
                },
            })
        }
    }

    return (
        <div className="relative w-full px-4 bg-no-repeat bg-cover mini:min-h-screen mini:h-full xl:h-height-main bg-sino">
            <p className="w-full py-5 italic font-bold text-center text-white mini:text-xl xl:text-4xl drop-shadow-lg">
                Tirada del Si o No
            </p>
            <div className="flex w-full mini:flex-col xl:flex-row">
                {/* left */}
                <div className="flex flex-col h-full gap-6 rounded-lg mini:w-full xl:w-1/2 bg-violetLight/70 mini:py-5 mini:px-2 md:p-5 shadow-card-horizontal">
                    <div className="flex flex-col gap-3">
                        <div className="flex gap-3 mini:flex-col md:flex-row">
                            <input
                            name="name"
                            type="text"
                            value={data.consultante.name}
                            onChange={(e) => handleInputConsultant(e)}
                            placeholder="Nombre del Consultante"
                            className="h-10 pl-3 text-base text-gray-400 rounded-lg mini:w-full md:w-1/2 focus-visible:outline-none focus-visible:border-violetDark focus-visible:border-2"
                            autoFocus={true}
                        />
                        <div className="flex gap-3">
                            <input
                                type="date"
                                name="date"
                                value={data.consultante.date}
                                onChange={(e) => handleInputConsultant(e)}
                                placeholder="Nacimiento"
                                className="w-1/2 pl-3 text-base text-gray-400 rounded-lg pr-1lh-10 focus-visible:outline-none focus-visible:border-violetDark focus-visible:border-2"
                            />
                            <input
                                type="text"
                                name="zodiac"
                                value={formatSignAndAge(data.consultante.zodiac, data.consultante.date)}
                                readOnly={true}
                                className="w-1/2 h-10 px-3 text-base text-gray-400 rounded-lg disabled:bg-white"
                                disabled={true}
                            />
                        </div>
                        <div className="flex items-center gap-1 text-white">
                            <button
                                className="p-2 rounded-full bg-violetDark hover:cursor-pointer disabled:bg-slate-400 disabled:text-slate-300 disabled:cursor-not-allowed"
                                onClick={() => copiar()}
                                title="Copiar"
                                disabled={data.consultante.name.length === 0 || data.consultante.zodiac.length === 0}
                            >
                                <ContentCopyIcon />
                            </button>
                            <button
                                className="p-2 rounded-full bg-violetDark hover:cursor-pointer"
                                onClick={() => pegar()}
                                title="Pegar"
                            >
                                                                                        <ContentPasteIcon />
                            </button>
                        </div>

                    </div>
                    </div>
                    <div>
                        <textarea
                            name="consult"
                            value={data.consulta}
                            className="p-3 h-[40vh] rounded-lg textr-base text-gray-400 w-full resize-none"
                            placeholder="Consulta"
                            onChange={(e) => handleConsult(e)}
                        />
                    </div>
                    <div className="flex flex-wrap justify-center gap-3 disabled:hidden">
                        <ButtonNormal
                            caption="Hecho"
                            onClick={() => handleStatus('isDone', true)}
                            disabled={
                                status.isDone ||
                                data.consultante.name.length === 0 ||
                                data.consultante.date.length === 0 ||
                                data.consulta.length === 0
                            }
                        />
                        <ButtonNormal
                            caption="Repartir"
                            onClick={() => mezcla()}
                            disabled={!status.isDone || status.repartidas}
                        />
                        <ButtonNormal
                            caption="Editar"
                            onClick={() => handleStatus('isDone', false)}
                            disabled={!status.isDone || status.repartidas}
                        />
                        <ButtonNormal
                            caption="Hacer foto de cartas"
                            onClick={() => setCopia(true)}
                            disabled={!status.repartidas || status.isConsulting}
                        />
                        <ButtonNormal
                            caption={status.isConsulting ? 'Interpretando' : 'Interpretar'}
                            onClick={() => interpretar()}
                            disabled={!status.repartidas || status.isInterpret}
                            loading={status.isConsulting}
                        />
                        <ButtonReinterpret
                            isConsulting={status.isConsulting}
                            onConfirm={() => interpretar()}
                            disabled={!status.isInterpret}
                            loading={status.isConsulting}
                        />
                        <ButtonNormal
                            caption="Ver Respuesta"
                            onClick={() => setShowResponse(true)}
                            disabled={response.length === 0}
                        />
                        <ButtonNormal
                            caption="Nueva Tirada"
                            onClick={() => nuevaPregunta()}
                            disabled={!status.isInterpret}
                        />
                        <ButtonNormal
                            caption="Nuevo Cliente"
                            onClick={() => nuevoCliente()}
                            disabled={!status.isInterpret}
                        />
                    </div>
                    <div className="w-full font-semibold text-red-400 bg-black h-[24px]">
                        <MarqueeText text={'Estás usando el mazo de cartas: ' + getMazoName(user.tarot)} speed={15} />
                    </div>
                </div>
                {/* right */}
                {selectedCards.length > 0 ? (
                    <div className="relative mini:w-full xl:w-1/2">
                        <ShowCards selectedCards={selectedCards} mazo={getMazo(user.tarot)} />
                    </div>
                ) : null}
                {selectedCards.length > 0 ? (
                    <div
                        className={`absolute top-0 left-0 w-screen h-screen flex justify-center items-center ${
                            copia ? 'block' : 'hidden'
                        }`}
                    >
                        <div className="w-fit h-fit" id="photo">
                            <PhotoCards cards={selectedCards} mazo={getMazo(user.tarot)} tapiz={getTapiz(user.tarot)} />
                        </div>
                    </div>
                ) : null}
                {showResponse ? (
                    <div className="absolute w-[90vw] h-[90vh] top-[2%] left-[5%] bg-zinc-200 shadow-2xl flex flex-row gap-5 rounded-xl mini:p-2 md:p-5">
                        <div className="flex flex-col gap-3 mini:w-full xl:w-2/3">
                            <textarea
                                className="w-full h-full rounded-lg resize-none mini:p-2 md:p-5"
                                value={response}
                                onChange={(e) => setResponse(e.target.value)}
                            />
                            <div className="flex flex-row flex-wrap justify-center gap-1">
                                <ButtonNormal caption="Volver" onClick={() => setShowResponse(false)} />
                                <ButtonNormal caption="Copiar Respuesta" onClick={() => copyResponse(response)} />
                                <ButtonNormal caption="Nueva Pregunta" onClick={() => nuevaPregunta()} />
                                <ButtonNormal caption="Nuevo Cliente" onClick={() => nuevoCliente()} />
                            </div>
                        </div>
                        <div className="flex flex-col w-1/3 gap-3 mini:hidden xl:block">
                            <p className="font-semibold">Consultante: {data.consultante.zodiac}</p>
                            <div
                                className="w-full p-5 overflow-y-auto text-sm rounded-lg bg-zinc-50"
                                id="consultante"
                            ></div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default Sino
